import "./styles.css";
 
interface ScoreBarProps {
  score: number;
  topMarkers?: string[] | number[];
  bottomLabels?: string[] | number[];
  reverse?: boolean
  maxScore?: number;
}
 
export function ScoreBarChart({
  score = 0,
  topMarkers = [],
  bottomLabels = [],
  reverse = false,
  maxScore = 1000,
}: ScoreBarProps) {
  const percentage = Math.min((score / maxScore) * 100, 100);
 
  return (
    <div className="score-container">
      <div className="score-display">
        <span className="score-value">{score}</span>
        <span className="score-point">/{maxScore}</span>
      </div>
 
      <div>
        <div className="score-markers">
          {topMarkers.map((value) => (
            <span key={value} className="marker-label-top">
              {value}
            </span>
          ))}
        </div>
 
        <div className="score-bar-container">
          <div className="score-pointer" style={{ left: `${percentage}%` }} />
          <div className={reverse ? "score-bar-reverse" : "score-bar"} />
        </div>
 
        <div className="bottom-labels">
          {bottomLabels.map((label) => (
            <div key={label} className="bottom-label">
              {label}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}